export default [
    {
        name: 'Стандартная',
        colors: {
            bg: '#121212',
            text: '#e0e0e0',
            accent: '#0ABAB5',
        },
    },
    {
        name: 'Классическая',
        colors: {
            bg: '#121212',
            text: '#e0e0e0',
            accent: '#b0b0b0',
        },
    },
    {
        name: 'Ночной закат',
        colors: {
            bg: '#1c1b20',
            text: '#e4e1e6',
            accent: '#c75b4e',
        },
    },
    {
        name: 'Тайный лес',
        colors: {
            bg: '#0c0e0b',
            text: '#dbe6db',
            accent: '#2a7f2a',
        },
    },
    {
        name: 'Звездная лаванда',
        colors: {
            bg: '#2b2738',
            text: '#eeedf5',
            accent: '#b39eb5',
        },
    },
    {
        name: 'Темные дюны',
        colors: {
            bg: '#2c2c2c',
            text: '#e5e5e5',
            accent: '#c9a775',
        },
    },
    {
        name: 'Полярная ночь',
        colors: {
            bg: '#1e2a3a',
            text: '#d9dde2',
            accent: '#66A6B3',
        },
    },
    {
        name: 'Темная клубника',
        colors: {
            bg: '#2e1e1e',
            text: '#ece5e5',
            accent: '#D94A64',
        },
    },
    {
        name: 'Золотая полночь',
        colors: {
            bg: '#1e1e1e',
            text: '#e5e5e5',
            accent: '#D4AF37',
        },
    },
    {
        name: 'Ночной город',
        colors: {
            bg: '#121212',
            text: '#dfdfdf',
            accent: '#FF8C00',
        },
    },
    {
        name: 'Лунная тень',
        colors: {
            bg: '#0A0A0A',
            text: '#dfdfdf',
            accent: '#8A5C72',
        },
    },
]
